import React from 'react';
import { IClub } from '../../../store/player/clubs/store';
import OfficerAvatar from '../ClubAbout/OfficerAvatar/OfficerAvatar';

interface IProps {
  club: IClub;
}

const EmptyItem = (): JSX.Element => (
  <div className="empty-item">There are no items to show in this category</div>
);

const ClubOfficers = ({ club }: IProps) => {
  return (
    <div className="club-officers-body">
      {club && club.managements !== undefined && club.managements.length !== 0 ? (
        club.managements.map((officer, index) => (
          <OfficerAvatar key={index} index={index} officer={officer} />
        ))
      ) : (
        <EmptyItem />
      )}
    </div>
  );
};

export default ClubOfficers;
